import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector,useDispatch } from "react-redux";
import { config } from "../../enviroment";
import faviconIcon from "../../assests/favicon.jpg";
import Favicon from "react-favicon";
import { commonService } from "../../services/common.service";
import { appContentapiLoading } from "../e_home-page/model/action";
import { useTranslation } from "react-i18next";
export default function TitleComponent() {
  const dispatch = useDispatch()
  const title = useSelector(
    (state) => state?.labels?.data?.getLabels?.HEADER?.TITLE
  );
  const [appDescription, setAppDesc] = useState("");
  const [favicon, setFavicon] = useState("");
  const {t:contents} = useTranslation("content-HEADER");
  const lang = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const favi = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.APPLICATION_FAVICON
  );
  useEffect(() => {
    (async()=>{
      if (lang) {
        dispatch(appContentapiLoading(false))
        setAppDesc(contents("APPLICATION_DESCRIPTION").answer);
      }
      if (favi) {
        
        await commonService.getAssestUrl(favi).then((resp) => {
          setFavicon(resp);
        });
      }
    })()
    
  }, [favi,lang]);//adding lang casuing issue

  const canonical = config.urls.BASE_URL;
  return (
    <>
      <Favicon url={favicon ? favicon.assetPath : faviconIcon} />
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={appDescription} />
        <link rel="canonical" href={canonical} />
        <link
          rel="apple-touch-icon"
          href={faviconIcon}
        />
        <link
          rel="shortcut icon"
          type="image/png"
          href={faviconIcon}
        />
        <link rel="icon" href={faviconIcon} />
      </Helmet>
    </>
  );
}
